import React from 'react';
import { FadeIn } from './FadeIn';
import { Award, BookOpen, Brain, Compass, Star, Users } from 'lucide-react';
export function Credentials() {
  const credentials = [{
    icon: Star,
    title: 'Master Trainer NLP',
    desc: 'Membru ARONLP și EANLP — cel mai înalt nivel de certificare în Programare Neuro-Lingvistică (2025).'
  }, {
    icon: Users,
    title: 'Facilitator Constelații Familiale',
    desc: 'Formare în lucrul cu sistemul familial și tiparele transgeneraționale, în curs de finalizare (2026).'
  }, {
    icon: Brain,
    title: 'Master Practitioner Hipnoză',
    desc: 'Certificat de Asociația Română de Hipnoză pentru tehnici de reglare profundă a subconștientului (2024).'
  }, {
    icon: BookOpen,
    title: 'Certificat de Formator',
    desc: 'Acreditat de Ministerul Muncii pentru proiectarea și livrarea de programe de dezvoltare personală (2024).'
  }, {
    icon: Compass,
    title: 'Master Coach ARONLP și EANLP',
    desc: 'Diplomă acreditată Ministerul Muncii pentru coaching la nivel master, integrat cu NLP (2022).'
  }, {
    icon: Award,
    title: 'Trainer Certificat DISC',
    desc: 'Certificat de John Maxwell Team România în evaluarea comportamentală și dezvoltarea leadership-ului (2020).'
  }];
  return <section className="relative py-20 md:py-28 bg-white overflow-hidden" data-id="element-295">
      {/* Organic blob background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-296">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-forest/5 rounded-full blur-3xl" data-id="element-297"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gold/5 rounded-full blur-3xl" data-id="element-298"></div>
      </div>

      <div className="max-w-[1100px] mx-auto px-6 md:px-8 relative z-10" data-id="element-299">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-300">
          <FadeIn data-id="element-301">
            <span className="inline-block font-display text-xs font-semibold tracking-[0.3em] text-gold-dark uppercase mb-4" data-id="element-302">
              Acreditări
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-303">
              Formare profesională și acreditări
            </h2>
            <p className="text-[19px] text-charcoal/80 font-sans" data-id="element-304">
              Lucrez într-un cadru etic și structurat, susținut de formare
              profesională continuă și instrumente validate în practica cu
              oameni reali.
            </p>
          </FadeIn>
        </div>

        {/* Horizontal rows: icon left, text right */}
        <div className="space-y-4" data-id="element-305">
          {credentials.map((cred, index) => {
          const Icon = cred.icon;
          return <FadeIn key={index} delay={index * 0.06} data-id="element-306">
                <div className="group flex items-start gap-5 md:gap-7 bg-ivory/40 hover:bg-ivory/70 border border-gold/15 hover:border-gold/30 rounded-2xl p-5 md:p-7 transition-all duration-300" data-id="element-307">
                  {/* Emblem / Logo */}
                  <div className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br from-forest to-forest-light flex items-center justify-center shadow-md shadow-forest/20 group-hover:scale-105 transition-transform duration-300" data-id="element-308">
                    <Icon className="w-6 h-6 md:w-7 md:h-7 text-gold" strokeWidth={1.8} data-id="element-309" />
                  </div>

                  {/* Title + Description */}
                  <div className="flex-1 min-w-0 pt-1" data-id="element-310">
                    <h3 className="text-lg md:text-xl font-serif font-medium text-forest mb-1.5" data-id="element-311">
                      {cred.title}
                    </h3>
                    <p className="text-[15px] md:text-[16px] text-charcoal/70 font-sans leading-relaxed" data-id="element-312">
                      {cred.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}